
(function () {

  const portfoliosTubs = document.querySelector('.portfolios-tubs');
  const portfoliosTubsBtns = document.querySelectorAll('.portfolios-tubs__btn');
  const portfoliosTubsItems = document.querySelectorAll('.gallery__item');
  const loadMore = document.querySelector('.portfolios-more');

  const isLoad_MoreNeeded = (selector) => {
    if (selector.length <= 3) {
      loadMore.classList.add('visually-hidden');
    } else {
      console.log(selector.length)
      loadMore.classList.remove('visually-hidden');
    }
  }


  portfoliosTubs.addEventListener('click', (e) => {

    const target = e.target;
    let portfoliosTubsItemsVisible = document.querySelectorAll('.gallery__item--visible');
    if (target.classList.contains('portfolios-tubs__btn')) {
      const path = target.dataset.path;
      // Выбор активных кнопок
      portfoliosTubsBtns.forEach(el => {
        el.classList.remove('portfolios-tubs__btn--active');
        target.classList.add('portfolios-tubs__btn--active');
      })
      // Скрываем все items
      portfoliosTubsItems.forEach(el => {
        el.classList.add('visually-hidden');
        // убираем у всех класс --visible
        el.classList.remove('gallery__item--visible');
        el.classList.remove('gallery__item--visible-more');
      })
      // выбрали нужный data-path атрибут и убрали скрытие именно им
      document.querySelectorAll(`[data-target="${path}"]`).forEach(el => {
        el.closest('.gallery__item').classList.remove('visually-hidden');
        el.closest('.gallery__item').classList.add('gallery__item--visible');

      });
      isLoad_MoreNeeded(document.querySelectorAll(`[data-target="${path}"]`));

      if (path == 'all') {
        portfoliosTubsItems.forEach((el, i) => {
          if (i <= 2) {
            el.classList.remove('visually-hidden');
            el.classList.add('gallery__item--visible');
          }
        })

        isLoad_MoreNeeded(document.querySelectorAll('.gallery__item'));
      }
      portfoliosTubsItemsVisible = document.querySelectorAll('.gallery__item--visible');
    }

    // isLoad_MoreNeeded(portfoliosTubsItemsVisible);
  });

  loadMore.addEventListener('click', (e) => {
    // const visibleItems = document.querySelectorAll('.gallery__item--visible');
    const path = document.querySelector('.portfolios-tubs__btn--active').dataset.path;
    if (path == 'all') {
      portfoliosTubsItems.forEach(el => {
        el.closest('.gallery__item').classList.remove('visually-hidden');
        el.closest('.gallery__item').classList.add('gallery__item--visible-more');
        loadMore.classList.add('visually-hidden');
      })
    } else {
      document.querySelectorAll(`[data-target="${path}"]`).forEach(el => {
        el.closest('.gallery__item').classList.remove('visually-hidden');
        el.closest('.gallery__item').classList.add('gallery__item--visible-more');
        loadMore.classList.add('visually-hidden');
      })
    }
  })
})();


// else if (path == 'sites') {
//   let portfoliosTubsItemsVisible = document.querySelectorAll('.gallery__item--visible');
//   if (portfoliosTubsItemsVisible.length <= 6) {
//     loadMore.classList.add('visually-hidden');
//   } else {
//     loadMore.classList.remove('visually-hidden');
//   }
// } else {
//   let portfoliosTubsItemsVisible = document.querySelectorAll('.gallery__item--visible');
//   if (portfoliosTubsItemsVisible.length <= 3) {
//     loadMore.classList.add('visually-hidden');
//   } else {
//     loadMore.classList.remove('visually-hidden');
//   }
// }

// (function () {
//   const portfoliosTubs = document.querySelector('.portfolios-tubs');
//   const portfoliosTubsBtns = document.querySelectorAll('.portfolios-tubs__btn');
//   const portfoliosTubsItems = document.querySelectorAll('.gallery__item');
//   const loadMore = document.querySelector('.portfolios-more')

//   portfoliosTubs.addEventListener('click', (e) => {
//     const target = e.target;
//     if (target.classList.contains('portfolios-tubs__btn')) {
//       const path = target.dataset.path;

//       portfoliosTubsBtns.forEach(el => {
//         el.classList.remove('portfolios-tubs__btn--active');
//         target.classList.add('portfolios-tubs__btn--active');
//       })

//       portfoliosTubsItems.forEach(el => {
//         el.classList.remove('gallery__item--visible');
//       })

//       document.querySelectorAll(`[data-target="${path}"]`).forEach(el => {
//         el.closest('.gallery__item').classList.add('gallery__item--visible')
//       })

//       if (path == 'all') {
//         portfoliosTubsItems.forEach(el => {
//           el.classList.add('gallery__item--visible');
//         })
//       }
//       const portfoliosTubsItemsVisible = document.querySelectorAll('.gallery__item--visible');
//       if (portfoliosTubsItemsVisible.length <= 3) {
//         loadMore.style.display('none');
//       } else {
//         loadMore.classList.remove('visually-hidden');
//       }
//     }
//   });
// })();
